import {type FunctionalComponent, h} from '@stencil/core';
import type {Strategies} from '../../../../../strategies/Strategies';
import type {CtaWidget} from '../../../../../widgets/cta-widget/cta-widget';

type WidgetsRowProps = {
  labelProvider: CallableFunction;
  country?: string;
  language?: string;
  strategies: Strategies,
};

type CtaWidgetDataProps = Partial<CtaWidget> & { iconName: string; library?: string; };

export const CtaWidgetsRow: FunctionalComponent<WidgetsRowProps> = (props
) => {

    const {
      country,
      language,
      strategies,
      labelProvider,
    } = props;

    const isDesignFirm = strategies?.strategyData?.cardType?.params?.designFirmWidgets;
    const isDistributorStockAvailable = strategies?.strategyData?.cardType?.params?.showDsaLink;


    const widgetData: CtaWidgetDataProps[] = [
      {
        header: labelProvider('dashboardCta.substitution.header', 'Product Substitution Tool'),
        content: labelProvider('dashboardCta.substitution.content', 'Get a replacement for a discontinued Schneider Electric product.'),
        url: '/myschneider/productSubsTool?search=',
        iconName: 'arrows-loop-rectangular',
      },

      {
        header: labelProvider('dashboardCta.products.header', 'Product Selector'),
        content: labelProvider('dashboardCta.products.content', 'Save time and easily find the right products and accessories for your applications – no need to log in.'),
        url: `/${country}/${language}/work/support/product-selector/`,
        iconName: 'squares-checked',
      },

      {
        header: labelProvider('distributorStockAvailability.helpWidget.title',
          'Contact support'),
        content: labelProvider( 'distributorStockAvailability.helpWidget.content',
          'Reach out to our customer service team for more information, technical support and more.'),
        url: '/myschneider/contact',
        iconName: 'rectangle-location-pin',
      }
    ];


    const designFirmwidgetData: CtaWidgetDataProps[] = [
      {
        header: labelProvider('dashboardCta.tool.header', 'EcoStruxure™ Specification Tool'),
        content: labelProvider('dashboardCta.tool.content', 'Generate detailed technical specifications for electrical and mechanical requirements!'),
        url: 'https://ecostruxure-specification.se.app/au/',
        iconName: 'breaker-signal-waves-left',
      },

      {
        header: labelProvider('dashboardCta.training.header', ' Looking for a training?'),
        content: labelProvider('dashboardCta.training.content', 'Access all available Training Courses tailored to your needs.'),
        url: ' https://schneider-electric.csod.com/ui/lms-learner-home/home',
        iconName: 'graduation-hat',
      },

      {
        header: labelProvider('dashboardCta.solutions.header', 'EcoStruxure™ Solutions for your Business'),
        content: labelProvider('dashboardCta.solutions.content', 'Access all the topics you need in one convenient place.'),
        url: `https://www.se.com/myschneider/content/${country}/en/cc/${country}/general/ecostruxure-for-segments.jsp`,
        iconName: 'cloud-book',
      }
    ];

    let dataSource = isDesignFirm ? designFirmwidgetData : widgetData;

    if (isDistributorStockAvailable) {
      dataSource = [{
        eventCategory: 'widget-cta-support-button',
        header: labelProvider('distributorStockAvailability.header', 'Distributor Stock Availability'),
        content: labelProvider('distributorStockAvailability.ctaWidget.content', 'Check stock status of our distribution partners with required quantities.'),
        url: '/myschneider/distributor-stock-availability',
        iconName: 'signal-waves-cube',
      } as CtaWidgetDataProps].concat(dataSource.slice(0,2));
    }

    return dataSource.map(({iconName, ...props}) =>
      <uiaas-search-cta-widget
        {...props}
        anchor-target="_blank"
        tab-name= "se/all"
        event-category= "widget-cta-support-button"
      >
        <qds-icon
          slot="icon"
          size="large" name={iconName}
          className="dashboard-widget-icon"
        />
      </uiaas-search-cta-widget>);
};
